import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';

// HS-1632: the layout of one installation — its detail (`.index`) and its edit form (`.edit`, HS-1633)
// mount in the outlet, as `devices.$id.tsx` does.
export const Route = createFileRoute('/_dashboard/installations/$id')({
  beforeLoad: requireRoute('/installations/$id'),
  component: Outlet,
});
